import logging from '@wr/logging';
import {getErrorStatusCode} from '../components/pages/PoliStatusWaiting/helpers';
import config from '../config';
import eventIds from '../event-ids';
import {throwOnResponseError} from '../utils/createResponseError';

const getAdyenStatus = async ({
    requestId, sessionId, query: {paymentSessionId, resultCode}
}) => {
    const logger = logging.createLogger(config.app.name, config.logger.logServerUrl);
    const logProps = {
        requestId, sessionId, paymentSessionId, resultCode
    };

    logger.info('Retrieving Adyen status', {
        eventId: eventIds['Retrieving Adyen status'],
        ...logProps
    });

    try {
        const url = new URL(`/api/sessions/${paymentSessionId}`, config.adyen.api);

        if (resultCode) {
            url.searchParams.set('resultCode', resultCode);
        }

        const responseStatus = await fetch(url.toString());

        throwOnResponseError(responseStatus);

        const status = await responseStatus.json();

        logger.info('Retrieved Adyen status', {
            eventId: eventIds['Retrieved Adyen status'],
            ...logProps,
            payload: status
        });

        return status;
    } catch (e) {
        const error = new Error(`Error retrieving Adyen status: ${e.message}`);
        error.status = getErrorStatusCode(e);

        logger.error(error.message, {
            eventId: eventIds['Error retrieving Adyen status'],
            ...logProps
        });

        throw error;
    }
};

export default getAdyenStatus;
